/* file description */

import * as React from 'react';
import { Button as PCButton } from 'antd';
import { Button as MobileButton } from 'antd-mobile';
import useMetaStore from '@/store/useMetaStore';
import { isMobileEnv } from '@/utils';

export const ButtonLayout = (props: any) => {
  const { isMobile = isMobileEnv() } = useMetaStore();

  if (isMobile) {
    let mobileTranformProps = props;
    if (props.type === 'link') {
      mobileTranformProps = { ...props, type: 'primary', fill: 'none' };
    }
    return (
      <MobileButton {...mobileTranformProps} color={mobileTranformProps.type} />
    );
  }

  return (
    <PCButton {...props} />
  );
};
